import { useClickOutside as useMantineClickOutside } from '@mantine/hooks';

export const useClickOutside = useMantineClickOutside;
